import { useState } from "react";
import {
  clearFreelancerFormData,
  getFreelancerFormData,
  updateFreelancerFormData,
} from "../../../utils/pip";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { setRegisterStep } from "../../../redux/features/find-a-job/reducers/authReducer";
import { freelancerSignUp } from "../../../redux/features/find-a-job/actions/authAction";
import Loader from "../../loader";

const RegisterStep2 = ({ backToLogin }) => {
  const dispatch = useDispatch();
  const { subLoading } = useSelector((state) => state.freelancer.auth);
  const savedData = getFreelancerFormData()?.step1 || {};

  const [talent_type, setTalent_type] = useState(savedData?.talent_type || "");
  const [showError, setShowError] = useState(false);

  const handleStep2 = () => {
    if (!talent_type) {
      setShowError(true);
      return toast.error("Please select an option to continue.");
    }

    if (!savedData?.full_name || !savedData?.email || !savedData?.password) {
      return toast.error("Please complete basic signup details first.");
    }

    setShowError(false);
    const { confirm_password, ...rest } = savedData || {};
    const payload = {
      ...rest,
      talent_type,
    };

    updateFreelancerFormData("step1", payload);

    const callback = (response) => {
      if (!response?.success) return;
      clearFreelancerFormData();
      dispatch(setRegisterStep(1));
      if (typeof backToLogin === "function") {
        backToLogin();
      }
    };

    dispatch(freelancerSignUp({ payload, callback }));
  };

  if (subLoading) {
    return <Loader />;
  }

  return (
    <div class="modal-body pe-0">
      <section class="ct_signup_main py-3">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
              <div class="ct_signup_left_img">
                <img
                  src="../assets/img/setp_2_freelance_img_left.png"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 ">
              <div class="ct_signup_right_content px-5 ct_custom_scroll">
                <div
                  className="ct_back_top_btn"
                  onClick={() => {
                    dispatch(setRegisterStep(1));
                  }}
                >
                  <i class="fa-solid fa-arrow-left"></i>
                </div>
                <div class="ct_signup_logo ct_mb_34">
                  <img src="../assets/img/Nuvio_logo.png" alt="" />
                </div>
                <div class="mt-0 text-center">
                  <h2 class="ct_fs_32  mb-0">
                    Sign Up to
                    <span class="ct_yellow_text"> Nuvio</span>
                  </h2>
                  <p
                    className="mb-0 ct_fs_16 mt-2 ct_darkblue_text mx-auto"
                    style={{ maxWidth: "500px" }}
                  >
                    Whether you want full access to full freelance tools or just
                    apply to curated job listings, we’ve got a plan for you
                  </p>
                </div>

                <form class="ct_mt_40">
                  <div className="row">
                    <div className="col-md-12">
                      <label htmlFor="option1" class="ct_signup_options_card d-flex align-items-center gap-3">
                        <div class="ct_signup_users_imges">
                          <img src="assets/img/user_trio_img.png" />
                        </div>
                        <div>
                          <h6 class="ct_fs_16 mb-2">I’m a freelancer</h6>
                          <p class="ct_grey_text mb-0 ct_fs_16">
                            I want to offer services and get hired for projects
                          </p>
                        </div>
                        <div class="ct_radio-container_check ms-auto">
                          <div class="ct_radio-wrapper_check">
                            <label class="ct_radio-button_check" >
                              <input
                                id="option1"
                                name="ct_radio-group"
                                type="radio"
                                value="FREELANCER"
                                checked={talent_type === "FREELANCER"}
                                onChange={(e) => {
                                  setTalent_type(e.target.value);
                                  setShowError(false);
                                }}
                              />
                              <span class="ct_radio-checkmark_check"></span>
                            </label>
                          </div>
                        </div>
                      </label>
                      <label  htmlFor="option2" class="ct_signup_options_card d-flex align-items-center gap-3 ct_mt_20">
                        <div class="ct_signup_users_imges">
                          <img src="assets/img/user_trio_img.png" />
                        </div>
                        <div>
                          <h6 class="ct_fs_16 mb-2">I’m a looking for a job</h6>
                          <p class="ct_grey_text mb-0 ct_fs_16">
                            I’m applying to open roles shared by clients.
                          </p>
                        </div>
                        <label class="ct_radio-container_check ms-auto">
                          <div class="ct_radio-wrapper_check">
                            <label class="ct_radio-button_check">
                              <input
                                id="option2"
                                name="ct_radio-group"
                                type="radio"
                                value="JOB_SEEKER"
                                checked={talent_type === "JOB_SEEKER"}
                                onChange={(e) => {
                                  setTalent_type(e.target.value);
                                  setShowError(false);
                                }}
                              />
                              <span class="ct_radio-checkmark_check"></span>
                            </label>
                          </div>
                        </label>
                      </label>
                      {showError && (
                        <p className="ct_fs_12 text-danger mt-2 mb-0">
                          Please select an option to continue.
                        </p>
                      )}
                    </div>
                    <div class="text-center mt-2">
                      <button
                        type="button"
                        onClick={handleStep2}
                        class="ct_yellow_btn  w-100 mx-auto"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>

                <div class=" text-center ct_mt_30 ct_darkblue_text">
                  Already have an account?{" "}
                  <a class="ct_orange_text" onClick={backToLogin}>
                    Sign In
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RegisterStep2;
